/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Search = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 39 40" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M37.476 39c-.384 0 .232.854-.06.56l-7.872-7.879a17.884 17.884 0 0 1-11.584 4.236 17.88 17.88 0 0 1-12.688-5.253 17.857 17.857 0 0 1-5.257-12.7c0-4.8 1.867-9.31 5.256-12.703A17.814 17.814 0 0 1 17.959.001c4.793 0 9.299 1.867 12.688 5.26 6.638 6.647 6.977 17.248 1.016 24.299l6.872 6.88a1.5 1.5 0 0 1-1.06 2.56zM18.006 2A15.888 15.888 0 0 0 6.697 6.685a15.887 15.887 0 0 0-4.684 11.308 15.89 15.89 0 0 0 4.685 11.31c6.236 6.235 16.381 6.236 22.617 0 6.236-6.236 6.236-16.382 0-22.618A15.887 15.887 0 0 0 18.005 2z" /><path d="M18.688 25.068H7.353c-.78-1.086-1.379-2.02-1.775-3.269 1.686.113 3.742.125 5.078.125 1.572 0 4.144-.017 5.933-.191 0 0 .51-1.527-.266-1.555-.107-.005-2.417-.1-5.667-.104-2.723.005-4.762.071-5.422.096-.15-.773-.234-1.311-.234-2.114 0-.903.102-2.166.291-3.032H20.36s.352 0 .187-.366c0 0-1.153-1.64-2.069-2.61H6.704c.587-1.005 1.32-2.19 2.189-3.034a289.3 289.3 0 0 1 2.049-.013c.057 0 5.881.016 6.775.16.858.141 1.22.295 1.604.48.186.09.304.145 2.718 3.312.33-.046.598-.06.64-.062h.002c2.289 0 3.043 1.106 3.166 1.318.194.325.2.687.015.995-.255.425-.86.666-1.535.8.65.888.395 1.01.43 1.083.12.242.411.938.379 1.915l-.1 3.355.002 3.4c0 1.245-.806 2.258-2.18 2.258h-2.173c-.982 0-1.45-1.666-1.905-2.73l-.092-.217zm-1-3.448c1.214-.11 2.891-.437 3.473-.608.585-.17.651-.592.651-.592.106-.934-.187-1.808-.187-1.808-.19-.6-.694-.67-1.07-.658-.438.015-1.735.986-1.735.986-.992.606-1.132 2.68-1.132 2.68z" />
      </g>
    </svg>
  </span>
);

Search.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Search.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Search;
